import * as t from 'typegate';
export const FieldSizes = {
    full: 12,
    threeQuarters: 9,
    twoThirds: 8,
    half: 6,
    third: 4,
    quarter: 3,
};
export const getFieldLayoutOptions = (t) => {
    const options = [
        FieldSizes.full,
        FieldSizes.threeQuarters,
        FieldSizes.twoThirds,
        FieldSizes.half,
        FieldSizes.third,
        FieldSizes.quarter,
    ];
    return options.map((option) => ({ label: t(option), value: option }));
};
export const fieldLayout = t.object(t.optionalProperty('size', t.tsEnum(FieldSizes)), t.optionalProperty('forceNewLine', t.boolean));
